export const STRUCTURAL_AGREEMENT_VARIABLE_KEYS = ["beneficiaries", "workTitles", "selectedTitleId"] as const;

const STRUCTURAL_KEYS = new Set<string>(STRUCTURAL_AGREEMENT_VARIABLE_KEYS);
const TITLE_SCOPED_VARIABLE_KEYS = new Set([
    "title",
    "ean13",
    "articleTitle",
    "articleReleaseDate",
    "articleFormat",
    "duration",
    "initialDraw",
]);

export const isStructuralAgreementVariableKey = (key: string) => STRUCTURAL_KEYS.has(key);

export const isTitleScopedAgreementVariableKey = (key: string, titleCustomFieldUuids?: Set<string>) => {
    if (TITLE_SCOPED_VARIABLE_KEYS.has(key)) return true;
    if (!key.startsWith("meta:")) return false;
    if (!titleCustomFieldUuids) return true;
    return titleCustomFieldUuids.has(key.slice(5));
};
